import React from "react";
import PropTypes from "prop-types";
import styles from "./styles/SpinnerMark.module.css";
import { Spinner } from "react-bootstrap";

const SpinnerMark = ({ size }) => {
  // state

  // variables

  // logics before hooks

  // hooks

  // logics

  // UI partials

  // effects

  // render
  return (
    <div className={styles.spinnerMask}>
      <div className="text-center">
        <Spinner animation="border" variant="danger" size={size} />
        <div className="text-danger">Loading...</div>
      </div>
    </div>
  );
};

/* required: display name */
SpinnerMark.displayName = "SpinnerMark";

/* required: props types */
SpinnerMark.propTypes = {};

/* required: default props */
SpinnerMark.defaultProps = { size: "md" };

export { SpinnerMark };
